import Index from "../../../container/Index";

export default function Loader() {
  return (
    <Index.Box className="loader-main">
      <Index.Box className="loader-2"></Index.Box>
    </Index.Box>
  );
}
